// --- batchCamelCasing
import camelCase from "lodash/camelCase"
import batchConvertCasing from "./batchConvertCasing.js"

export default function batchCamelCasing ( payload ) {
    return batchConvertCasing( payload, camelCase )
}